module.exports = __webpack_public_path__ + "static/media/YF38_1.a2274c59.jpg";